import { useGetUserQuery } from 'api';
import { includes, sortBy } from 'lodash';
import { useEffect } from 'react';
import { useAuthStore } from 'stores/authStore';
import { isFaksRole, isResourceScopedRole } from 'utils/rolesUtils';

export const useCurrentUserAndValidateRoles = () => {
  const authToken = useAuthStore((state) => state.userToken);
  const currentUserId = useAuthStore((state) => state.currentUserId);
  const currentRoleId = useAuthStore((state) => state.currentRoleId);
  const setTrueUserId = useAuthStore((state) => state.setTrueUserId);
  const setCurrentUserId = useAuthStore((state) => state.setCurrentUserId);
  const setCurrentRoleId = useAuthStore((state) => state.setCurrentRoleId);

  const { data } = useGetUserQuery({ enabled: !!authToken, refetchOnWindowFocus: true });

  useEffect(() => {
    if (!data) return;

    setTrueUserId(data.meta.true_user_id);
    if (!currentUserId) {
      setCurrentUserId(data.user.id);
    }

    const resourceRoles = data.user.roles?.filter(isResourceScopedRole);

    const rolesWithAccess = resourceRoles
      ?.filter((role) => !includes(['lab_sales_rep_no_access', 'no_access'], role.kind))
      .sort((a, b) => (a.resource.name || '').localeCompare(b.resource.name || ''));

    const currentRole = data.user.roles?.find((role) => role.id === currentRoleId);
    const faksRole = data.user.roles?.find(isFaksRole);

    const roleToUse =
      currentRole || faksRole || sortBy(rolesWithAccess || resourceRoles || [], ['id'])[0] || null;

    // Important to avoid unwanted false positive because undefined !== null
    const realRoleToUseId: number | null = roleToUse ? roleToUse.id : null;

    if (realRoleToUseId !== currentRoleId) {
      setCurrentRoleId(realRoleToUseId);
    }
  }, [data, currentUserId, currentRoleId, setTrueUserId, setCurrentUserId, setCurrentRoleId]);

  return data ? { currentUser: data.user, trueUserId: data.meta.true_user_id } : null;
};
